import React, { useState } from "react";
import './BotonFlotante.css'
import avatar from './img/Imagen1.png'

export const BotonFlotante =  (props) => {
    const {} = props;

    const [ popUp, setPopUp ] = useState(false);

    return(
        <>
            <div className={`buttonFloat ${popUp ? 'activeClass' : ''}`} onClick={()=> {popUp ? setPopUp(false): setPopUp(true)}}>
                {popUp ? ('X'):('¿Necesitas ayuda?')}
            </div>
            {
                popUp && (
                    <div className="ventana-popup">
                        <div className="contenido-popup">
                            {/* <img src={avatar}/> */}
                            <iframe src="https://www.youtube.com/embed/p2rgGbp36K0?si=bWd2iViaREnIkCDS" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                    </div>
                )
            }
        </>
    )
};